export default __webpack_public_path__ + "static/img61h-52f0be2140ca8285d0b91f13d87f0c18.jpg";